let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3xImw")).then(() => parcelRequire('4opAu'));